import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Register.css"; // We'll create this file
import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";
import "font-awesome/css/font-awesome.min.css";
import GitHubLogin from "react-github-login";
import { jwtDecode } from "jwt-decode";
import { toast } from "react-hot-toast";
import { Helmet } from "react-helmet";


const Register = () => {

  
<Helmet>
  <title>Register – V-Editor Online Code Editor</title>
  <meta
    name="description"
    content="Create a free account on V-Editor to start coding online in Python, JavaScript, HTML, CSS, PHP, and C++. Collaborate in real-time and use AI-powered code suggestions."
  />
  <meta
    name="keywords"
    content="V-Editor register, sign up online code editor, Python editor account, JavaScript editor account, HTML CSS editor signup"
  />
  <meta name="robots" content="index, follow" />
</Helmet>

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [acceptTerms, setAcceptTerms] = useState(false);
  const [showTermsModal, setShowTermsModal] = useState(false);
  const [passwordStrength, setPasswordStrength] = useState(0);
  const [passwordErrors, setPasswordErrors] = useState([]);

  const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_IDS;
  const GITHUB_CLIENT_ID = process.env.REACT_APP_GITHUB_CLIENT_ID;
  const navigate = useNavigate();

  const validateEmail = (email) =>
    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email);

  // Password strength checker
  const checkPasswordStrength = (pwd) => {
    const errors = [];
    let strength = 0;

    if (pwd.length >= 8) strength += 25;
    else errors.push("At least 8 characters");

    if (/[A-Z]/.test(pwd)) strength += 25;
    else errors.push("One uppercase letter");

    if (/[0-9]/.test(pwd)) strength += 25;
    else errors.push("One number");

    if (/[^A-Za-z0-9]/.test(pwd)) strength += 25;
    else errors.push("One special character");

    setPasswordStrength(strength);
    setPasswordErrors(errors);
    return errors.length === 0;
  };

  useEffect(() => {
    if (password) {
      checkPasswordStrength(password);
    } else {
      setPasswordStrength(0);
      setPasswordErrors([]);
    }
  }, [password]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validation
    if (!acceptTerms) {
      toast.error("Please accept the Terms & Conditions");
      return;
    }
    
    if (!validateEmail(email)) {
      toast.error("Please enter a valid email address");
      return;
    }
    
    if (password !== confirmPassword) {
      toast.error("Passwords do not match");
      return;
    }
    
    if (!checkPasswordStrength(password)) {
      toast.error("Password does not meet requirements");
      return;
    }

    setLoading(true);
    setMessage("");

    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/register.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          signUp: true,
          fName: firstName,
          lName: lastName,
          email,
          password,
        }),
      });

      const result = await res.json();
      setLoading(false);

      if (result.success) {
        toast.success(result.message || "Registration successful! Redirecting to login...");
        if (result.token) localStorage.setItem("token", result.token);
        setTimeout(() => {
          navigate("/login", {
            state: {
              firstName: result.fName,
              lastName: result.lName,
              email: result.email,
            },
          });
        }, 1500);
      } else {
        setMessage(result.message);
        toast.error(result.message || "Registration failed");
      }
    } catch (err) {
      setLoading(false);
      setMessage("Something went wrong. Please try again.");
      toast.error("Network error. Please try again.");
      console.error(err);
    }
  };

  // Google Register
  const handleGoogleSuccess = async (credentialResponse) => {
    const decoded = jwtDecode(credentialResponse.credential);

    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/register.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          provider: "google",
          firstName: decoded.given_name,
          lastName: decoded.family_name || "",
          email: decoded.email,
          picture: decoded.picture,
        }),
      });

      const result = await res.json();

      if (result.success) {
        toast.success("Google registration successful!");
        if (result.token) localStorage.setItem("token", result.token);
        navigate("/home", { state: result });
      } else {
        toast.error(result.message);
      }
    } catch (err) {
      console.error(err);
      toast.error("Google registration failed");
    }
  };

  const handleGitHubSuccess = async (response) => {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/register.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          provider: "github",
          github_code: response.code,
        }),
      });

      const result = await res.json();

      if (result.success) {
        toast.success("GitHub registration successful!");
        if (result.token) localStorage.setItem("token", result.token);
        navigate("/home", { state: result });
      } else {
        toast.error(result.message);
      }
    } catch (err) {
      console.error(err);
      toast.error("GitHub registration failed");
    }
  };

  // Modal Component
  const Modal = ({ show, onClose, title, icon, iconColor, children }) => {
    if (!show) return null;
    
    return (
      <div className="modal-overlay" onClick={onClose}>
        <div className="modal-content" onClick={(e) => e.stopPropagation()}>
          <div className="modal-header">
            <h5>
              <i className={icon} style={{ marginRight: "10px", color: iconColor }} />
              {title}
            </h5>
            <button className="modal-close" onClick={onClose}>
              &times;
            </button>
          </div>
          <div className="modal-body">
            {children}
          </div>
          <div className="modal-footer">
            <button className="modal-btn" onClick={onClose}>
              Close
            </button>
          </div>
        </div>
      </div>
    );
  };

  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <div className="register-page">
        {/* Terms Modal */}
        <Modal
          show={showTermsModal}
          onClose={() => setShowTermsModal(false)}
          title="Terms & Conditions"
          icon="fa fa-file-text"
          iconColor="#007bff"
        >
          <div className="terms-content">
            <p><strong>By creating an account with V-Editor, you agree to:</strong></p>
            <ul>
              <li>Use the service for lawful purposes only</li>
              <li>Not share inappropriate or harmful content</li>
              <li>Respect other users' privacy and intellectual property</li>
              <li>Accept that this is a beta version and may contain bugs</li>
              <li>Report any security vulnerabilities or issues</li>
              <li>Not attempt to reverse engineer or hack the service</li>
              <li>Maintain the security of your account credentials</li>
              <li>Accept that we may update these terms periodically</li>
            </ul>
            <p className="note">Full terms available at <Link to="/terms" onClick={() => setShowTermsModal(false)}>Terms of Service</Link></p>
          </div>
        </Modal>

        <div className="register-container">
          <div className="register-card">
            <div className="register-header">
              <h1 className="register-title">
                <i className="fa fa-user-plus" style={{ marginRight: "10px" }} />
                Create Your Account
              </h1>
              <p className="register-subtitle">Join V-Editor and start creating amazing content</p>
            </div>

            {/* Terms Acceptance */}
            <div className="terms-section">
              <div className="terms-header">
                <i className="fa fa-exclamation-circle" />
                <span>To register, please accept:</span>
              </div>
              
              <div className="terms-checkboxes">
                <div className="form-check term-item">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="termsCheck"
                    checked={acceptTerms}
                    onChange={(e) => setAcceptTerms(e.target.checked)}
                    required
                  />
                  <label className="form-check-label" htmlFor="termsCheck">
                    I agree to the{" "}
                    <button 
                      type="button"
                      className="link-btn"
                      onClick={() => setShowTermsModal(true)}
                    >
                      Terms & Conditions
                    </button>
                    {" "}*
                  </label>
                </div>
              </div>
              
              <div className="terms-note">
                <i className="fa fa-info-circle" />
                <span>By registering, you also agree to our <Link to="/privacy">Privacy Policy</Link></span>
              </div>
            </div>

            {/* Registration Form */}
            <form onSubmit={handleSubmit} className="register-form" autoComplete="off">
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="firstName" className="form-label">
                      <i className="fa fa-user" />
                      First Name
                    </label>
                    <input
                      type="text"
                      id="firstName"
                      className="form-control"
                      placeholder="Enter your first name"
                      value={firstName}
                      onChange={(e) => setFirstName(e.target.value)}
                      required
                      autoComplete="given-name"
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="lastName" className="form-label">
                      <i className="fa fa-user" />
                      Last Name
                    </label>
                    <input
                      type="text"
                      id="lastName"
                      className="form-control"
                      placeholder="Enter your last name"
                      value={lastName}
                      onChange={(e) => setLastName(e.target.value)}
                      required
                      autoComplete="family-name"
                    />
                  </div>
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="email" className="form-label">
                  <i className="fa fa-envelope" />
                  Email Address
                </label>
                <input
                  type="email"
                  id="email"
                  className="form-control"
                  placeholder="Enter your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  autoComplete="email"
                />
                <div className="form-text">
                  We'll never share your email with anyone else.
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="password" className="form-label">
                  <i className="fa fa-lock" />
                  Password
                </label>
                <input
                  type="password"
                  id="password"
                  className="form-control"
                  placeholder="Create a strong password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  autoComplete="new-password"
                />
                
                {/* Password Strength Meter */}
                {password && (
                  <div className="password-strength">
                    <div className="strength-meter">
                      <div 
                        className="strength-bar"
                        style={{ width: `${passwordStrength}%` }}
                        data-strength={
                          passwordStrength < 50 ? 'weak' : 
                          passwordStrength < 75 ? 'medium' : 'strong'
                        }
                      ></div>
                    </div>
                    <div className="strength-label">
                      Strength:{" "}
                      <span className={
                        passwordStrength < 50 ? 'text-danger' : 
                        passwordStrength < 75 ? 'text-warning' : 'text-success'
                      }>
                        {passwordStrength < 50 ? 'Weak' : 
                         passwordStrength < 75 ? 'Medium' : 'Strong'}
                      </span>
                    </div>
                    
                    {passwordErrors.length > 0 && (
                      <div className="password-requirements">
                        <small className="text-muted">Requirements:</small>
                        <ul className="requirement-list">
                          {passwordErrors.map((error, index) => (
                            <li key={index} className="requirement-item">
                              <i className="fa fa-times text-danger me-2" />
                              {error}
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </div>
                )}
              </div>

              <div className="form-group">
                <label htmlFor="confirmPassword" className="form-label">
                  <i className="fa fa-lock" />
                  Confirm Password
                </label>
                <input
                  type="password"
                  id="confirmPassword"
                  className="form-control"
                  placeholder="Confirm your password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                  autoComplete="new-password"
                />
                {confirmPassword && password !== confirmPassword && (
                  <div className="text-danger mt-2">
                    <i className="fa fa-exclamation-triangle me-2" />
                    Passwords do not match
                  </div>
                )}
                {confirmPassword && password === confirmPassword && password && (
                  <div className="text-success mt-2">
                    <i className="fa fa-check-circle me-2" />
                    Passwords match
                  </div>
                )}
              </div>

              <button 
                type="submit" 
                className="register-btn"
                disabled={loading || !acceptTerms}
              >
                {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" />
                    Creating Account...
                  </>
                ) : (
                  <>
                    <i className="fa fa-user-plus me-2" />
                    Create Account
                  </>
                )}
              </button>
            </form>

            <div className="divider">
              <span>OR SIGN UP WITH</span>
            </div>

            <div className="social-logins">
              <GoogleLogin 
                onSuccess={handleGoogleSuccess} 
                onError={() => toast.error("Google sign-up failed")}
                size="large"
                width="100%"
              />
              
              <GitHubLogin
                clientId={GITHUB_CLIENT_ID}
                onSuccess={handleGitHubSuccess}
                onFailure={() => toast.error("GitHub sign-up failed")}
                redirectUri="https://veditor.in/auth/github/callback"
                className="github-btn"
              >
                <i className="fa fa-github me-2" />
                Sign up with GitHub
              </GitHubLogin>
            </div>

            <div className="register-footer">
              <p className="have-account">
                Already have an account?
                <button 
                  className="login-link"
                  onClick={() => navigate("/login")}
                >
                  Sign In
                </button>
              </p>
              
              <div className="legal-note">
                <p>
                  By creating an account, you agree to our{" "}
                  <Link to="/terms">Terms of Service</Link> and{" "}
                  <Link to="/privacy">Privacy Policy</Link>.
                </p>
              </div>
            </div>

            {message && (
              <div className="alert alert-info alert-dismissible fade show" role="alert">
                {message}
                <button 
                  type="button" 
                  className="btn-close" 
                  onClick={() => setMessage("")}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </GoogleOAuthProvider>
  );
};

export default Register;